import React, { Component } from 'react';
import AuthService from '../utils/AuthService';
import ConfigurationGroup from './ConfigurationGroup';

class ConfigurationForm extends Component {
		constructor(props) {
				super(props);

				this.state = {
						numConfigurations: 1,
						configData: [
								{
										title: 'Configuration 1'
								}
						],
						seakeepers: []
				};
				
				this.Auth = new AuthService();
				//this.addConfiguration = this.addConfiguration.bind(this);
				this.updatedConfigGroup = this.updatedConfigGroup.bind(this);

				this.newUpdatedConfigGroup = this.newUpdatedConfigGroup.bind(this);
				this.addSeakeeper = this.addSeakeeper.bind(this);
				this.deleteConfiguration = this.deleteConfiguration.bind(this);
		}

		componentDidMount() {
			this.Auth.fetch("/pp-seakeepers")
			.then(
				(result) => {
					if(result) {
						this.setState({
							seakeepers: result
						});
					} else {
						if(result.errors) {
							alert(result.errors.join("\n"));
						}
					}
				},
				(error) => {
					this.setState({
						error
					});
				}
			)
		}

		// addConfiguration() {
		// 		let numConfigurations = this.state.numConfigurations,
		// 				configData = this.state.configData;
		//
		// 		numConfigurations += 1;
		// 		configData.push({
		// 				title: 'Configuration ' + numConfigurations
		// 		});
		//
		// 		this.setState({
		// 				numConfigurations: numConfigurations,
		// 				configData: configData
		// 		});
		// }

		updatedConfigGroup(configIndex, seakeeperData) {
			let tempConfigData = this.state.configData;

			tempConfigData[configIndex] = {
				...tempConfigData[configIndex],
				"seakeeperData": seakeeperData
			};

			this.setState({
				configData: tempConfigData
			}, this.updateParent);
		}

		newUpdatedConfigGroup(configIndex, skIndex, data) {
			this.props.onChange(configIndex, skIndex, data);
		}

		addSeakeeper(configIndex) {
			this.props.addConfigSeakeeper(configIndex);
		}

		updateParent() {
			this.props.onChange(this.state.configData);
		}

		deleteConfiguration(configIndex) {
			this.props.deleteConfiguration(configIndex);
		}

		render() {
				const { seakeepers } = this.state;
				const { configInfo } = this.props;
				
				return (
						<div className="pp-configuration-form">
								<h3 className="pp-form-title">Seakeeper Configurations</h3>
								<p className="pp-form-description">Create up to three Seakeeper configurations with up to two Seakeeper models per configuration.</p>
								{this.props.sizingCalculator &&
									<p className="pp-sizing-calculator-message">The recommended Seakeeper based on the sizing calculator is the Seakeeper {this.props.sizingCalculator}.</p>
								}
								{configInfo &&
									configInfo.map((data, index) => (
										<ConfigurationGroup
											key={index}
											order={index}
											configIndex={data.index}
											configID={data.configID}
											title={data.title}
											seakeeperList={seakeepers}
											onChange={this.newUpdatedConfigGroup}
											seakeeperData={data.seakeeperData}
											addSeakeeper={this.addSeakeeper}
											disableAddSeakeeper={data.disableAddSeakeeper || false}
											deleteConfiguration={this.deleteConfiguration}
											deleteModel={this.props.deleteConfigSeakeeper}
											canRecommend={this.props.canRecommend}
											canShowHide={this.props.canShowHide}
											updateRecommendConfig={this.props.updateRecommendConfig}
											isRecommended={(data.configID == this.props.recommendedConfiguration && this.props.recommendedConfiguration !== null) ? "true" : "false"}
											showConfig={data.showConfig}
											disableAll={this.props.disableAll}
											changeShowHide={this.props.changeShowHide}
										/>
									))
								}

								{(!this.props.disableAddConfiguration && !this.props.disableAll) &&
									<button className="pp-add-configuration" onClick={this.props.addConfiguration}>Add Additional Configuration</button>
								}
						</div>
				);
		}
}

export default ConfigurationForm;



// WEBPACK FOOTER //
// ./src/components/ConfigurationForm.js